// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__WQq4N","content":"style_content__KmfJ8","description":"style_description__N-bFi"};